import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SendIcon from "@mui/icons-material/Send";
import { observer } from "mobx-react";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import AppContainer from "src/components/AppContainer";
import css from "./resgister.module.scss";
import { useStore } from "src/providers/store";
import { IVehicle } from "src/models/vehicle";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import storageApi from "src/api/storageApi";

const ResgisterPage = () => {
  const { vehicle } = useStore();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const fileRef = useRef();

  const vehicleTypes = [
    { value: "car" },
    { value: "motorcycle" },
    { value: "van" },
    { value: "truck" },
  ];

  const [vehicleData, setVehicleData] = useState<IVehicle>({
    _id: undefined,
    status: undefined,
    approveStatus: "pending",
    travelType: "arrival",
    vehicleType: "",
    licensePlate: "",
    country: "",
    province: "",
    travelByOwner: true,
    carBook: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfCarOwner: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfOwnerIDcard: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfOwnerPassport: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfTax: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM2: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM3: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM4: {
      url: "",
      isPassed: false,
      remark: "",
    },
    TM5: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfPowerOfAttorney: {
      url: "",
      isPassed: false,
      remark: "",
    },
    originalPowerOfAttorney: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyOfIDcardGrantee: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyofCompany: {
      url: "",
      isPassed: false,
      remark: "",
    },
    copyofCompanyIDcardGrantor: {
      url: "",
      isPassed: false,
      remark: "",
    },
    phoneNumber: "",
    facebookID: "",
    lineID: "",
    email: "",
    token: "",
    remark: "",
    barcode: "",
    created: undefined,
  });

  const [isLoading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [path, setPath] = useState({
    carBook: "",
    copyOfCarOwner: "",
    copyOfOwnerIDcard: "",
    copyOfOwnerPassport: "",
    copyOfTax: "",
    TM2: "",
    TM3: "",
    TM4: "",
    TM5: "",
    copyOfPowerOfAttorney: "",
    originalPowerOfAttorney: "",
    copyOfIDcardGrantee: "",
    copyofCompany: "",
    copyofCompanyIDcardGrantor: "",
  });

  useEffect(() => {
    setLoading(false);
    setIsUploading(false);
  }, []);

  const onBackClicked = () => {
    navigate(-1);
  };

  const onValueChange =
    (prop: keyof IVehicle) => (event: React.ChangeEvent<HTMLInputElement>) => {
      if (prop !== "travelByOwner") {
        setVehicleData({ ...vehicleData, [prop]: event.target.value });
      } else {
        setVehicleData({ ...vehicleData, [prop]: event.target.checked });
      }
    };

  const onClickUpload = (key) => {
    setIsUploading(true);
    setFileName(key);
  };
  const handleFocusBack = () => {
    window.removeEventListener("focus", handleFocusBack);
    setIsUploading(false);
  };
  const onChangeFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    const targetKey = fileName || event.target.id;
    if (!file || !targetKey) {
      setIsUploading(false);
      return;
    }

    setPath({
      ...path,
      [targetKey]: file.name,
    });

    try {
      const requestFileName = `${Date.now()}_${file.name}`;
      const response = await storageApi.postUploadUrl({
        fileName: requestFileName,
        fileType: file.type || "application/octet-stream",
      });
      const signedUrl = response?.url;
      if (!signedUrl) {
        throw new Error("Signed upload URL not found");
      }

      const uploadResponse = await fetch(signedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
        body: file,
      });
      if (!uploadResponse.ok) {
        throw new Error(`Upload failed with status ${uploadResponse.status}`);
      }

      setVehicleData({
        ...vehicleData,
        [targetKey]: {
          url: requestFileName,
          isPassed: false,
          remark: "",
        },
      });
    } catch {
      setPath({
        ...path,
        [targetKey]: "",
      });
      alert(t("saveFail"));
    } finally {
      setIsUploading(false);
      event.target.value = "";
    }
  };
  const onClickDeleteFile = (key) => {
    setPath({
      ...path,
      [key]: "",
    });
    setVehicleData({
      ...vehicleData,
      [key]: {
        url: "",
        isPassed: false,
        remark: "",
      },
    });
  };
  const getFileNameValue = (key) => {
    switch (key) {
      case "carBook":
        return path.carBook;
      case "copyOfCarOwner":
        return path.copyOfCarOwner;
      case "copyOfOwnerIDcard":
        return path.copyOfOwnerIDcard;
      case "copyOfOwnerPassport":
        return path.copyOfOwnerPassport;
      case "copyOfTax":
        return path.copyOfTax;
      case "TM2":
        return path.TM2;
      case "TM3":
        return path.TM3;
      case "TM4":
        return path.TM4;
      case "TM5":
        return path.TM5;
      case "copyOfPowerOfAttorney":
        return path.copyOfPowerOfAttorney;
      case "originalPowerOfAttorney":
        return path.originalPowerOfAttorney;
      case "copyOfIDcardGrantee":
        return path.copyOfIDcardGrantee;
      case "copyofCompany":
        return path.copyofCompany;
      case "copyofCompanyIDcardGrantor":
        return path.copyofCompanyIDcardGrantor;
      default:
        return "";
    }
  };
  const getFileRequired = (key) => {
    switch (key) {
      case "copyOfOwnerIDcard":
        return false;
      case "copyOfOwnerPassport":
        return false;
      case "TM3":
        return false;
      case "copyofCompany":
        return false;
      case "copyofCompanyIDcardGrantor":
        return false;
      default:
        return true;
    }
  };

  const onSubmit = async (event) => {
    console.log(vehicleData);

    event.preventDefault();
    if (!isValid()) {
      return;
    }

    try {
      await vehicle.postVehicle(vehicleData);
      // if (!response) {
      //   alert(t("saveFail"));
      //   return;
      // }

      alert(t("saveSuccess"));
      navigate("/");
    } catch (error) {
      // const backendMessage =
      //   error?.response?.data?.message ||
      //   error?.response?.data?.error ||
      //   error?.message ||
      //   "Save failed";
      alert(t("saveFail"));
    }
  };

  const isValid = () => {
    if (!vehicleData.travelType) return false;
    if (!vehicleData.licensePlate) return false;
    if (!vehicleData.country) return false;
    if (!vehicleData.province) return false;

    if (!vehicleData.carBook.url) return false;
    if (!vehicleData.copyOfCarOwner.url) return false;
    // if (!vehicleData.copyOfOwnerIDcard.url) return false;
    if (!vehicleData.copyOfTax.url) return false;
    if (!vehicleData.TM2.url) return false;
    // if (!vehicleData.TM3.url) return false;
    // if (!vehicleData.TM4.url) return false;

    if (!vehicleData.travelByOwner) {
      // if (!vehicleData.copyOfPowerOfAttorney.url) return false;
      if (!vehicleData.originalPowerOfAttorney.url) return false;
      if (!vehicleData.copyOfIDcardGrantee.url) return false;
    }
    return true;
  };

  const textFieldUpload = (key, label) => {
    return (
      <Box className={css.flexInline}>
        <TextField
          id="carBook"
          label={label}
          value={getFileNameValue(key)}
          fullWidth
          disabled
          required={getFileRequired(key)}
          style={{ marginRight: "8px" }}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment
                position="end"
                style={
                  getFileNameValue(key) === ""
                    ? { display: "none" }
                    : { display: "flex" }
                }
              >
                <IconButton
                  aria-label="upload"
                  edge="end"
                  color="error"
                  onClick={() => onClickDeleteFile(key)}
                >
                  <HighlightOffIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <label>
          <Input
            id={key}
            type="file"
            ref={fileRef}
            style={{ display: "none" }}
            onChange={onChangeFileUpload}
            onClick={() => window.addEventListener("focus", handleFocusBack)}
          />
          <LoadingButton
            onClick={() => onClickUpload(key)}
            loading={isUploading}
            loadingPosition="start"
            startIcon={<FileUploadIcon />}
            variant="contained"
            component="span"
            color="error"
            style={{ height: "100%" }}
          >
            Upload
          </LoadingButton>
        </label>
      </Box>
    );
  };

  return (
    <AppContainer
      showAppBar
      showLang
      showFooter
      isLoading={isLoading}
      title={t("registerPage.title")}
      className={css.appContainer}
    >
      <Container className={css.container}>
        <Box className={css.navBar}>
          <span onClick={onBackClicked} className={css.action}>
            <ArrowBack className={css.icon} /> {t("adminDetailPage.back")}
          </span>
        </Box>
        <form onSubmit={onSubmit}>
          <Card sx={{ minWidth: 275 }} className={css.card}>
            <CardHeader title={t("vehicleInfo")}></CardHeader>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormLabel>{t("travelType")}</FormLabel>
                  <RadioGroup
                    value={vehicleData.travelType}
                    onChange={onValueChange("travelType")}
                    name="radio-buttons-group"
                    row
                  >
                    <FormControlLabel
                      value="arrival"
                      control={<Radio />}
                      label={t<string>("arrival")}
                    />
                    <FormControlLabel
                      value="departure"
                      control={<Radio />}
                      label={t<string>("departure")}
                    />
                  </RadioGroup>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>{t("vehicleType")}</InputLabel>
                    <Select
                      id="vehicleType"
                      required
                      value={vehicleData.vehicleType}
                      label={t("vehicleType")}
                      onChange={onValueChange("vehicleType")}
                    >
                      {vehicleTypes.map((vehicleType, index) => (
                        <MenuItem key={index} value={vehicleType.value}>
                          {t("constant.vehicleType." + vehicleType.value)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    id="registration"
                    label={t("registration")}
                    variant="outlined"
                    placeholder={t("registration")}
                    value={vehicleData.licensePlate}
                    onChange={onValueChange("licensePlate")}
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    id="province"
                    label={t("province")}
                    variant="outlined"
                    placeholder={t("province")}
                    value={vehicleData.province}
                    onChange={onValueChange("province")}
                    fullWidth
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    id="country"
                    label={t("country")}
                    variant="outlined"
                    placeholder={t("country")}
                    value={vehicleData.country}
                    onChange={onValueChange("country")}
                    fullWidth
                    required
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card sx={{ minWidth: 275 }} className={css.card}>
            <CardHeader title={t("attachedFile")}></CardHeader>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {textFieldUpload("carBook", t("carBook"))}
                </Grid>
                <Grid item xs={12}>
                  {textFieldUpload("copyOfCarOwner", t("copyOfCarOwner"))}
                </Grid>
                <Grid item xs={12}>
                  {textFieldUpload("copyOfOwnerIDcard", t("copyOfOwnerIDcard"))}
                </Grid>
                <Grid item xs={12}>
                  {textFieldUpload(
                    "copyOfOwnerPassport",
                    t("copyOfOwnerPassport"),
                  )}
                </Grid>
                <Grid item xs={12}>
                  {textFieldUpload("copyOfTax", t("copyOfTax"))}
                </Grid>
                <Grid item xs={12}>
                  {textFieldUpload("TM2", t("TM2"))}
                </Grid>
                <Grid item xs={12}>
                  {textFieldUpload("TM3", t("TM3"))}
                </Grid>
                {/* <Grid item xs={12}>
                  {textFieldUpload("TM4", t("TM4"))}
                </Grid> */}
                {/* <Grid item xs={12}>
                  {textFieldUpload("TM5", t("TM5"))}
                </Grid> */}
              </Grid>
            </CardContent>
          </Card>

          <Card sx={{ minWidth: 275 }} className={css.card}>
            <CardContent>
              <Box className={css.travelByOwner}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={vehicleData.travelByOwner}
                      onChange={onValueChange("travelByOwner")}
                      name={t<string>("travelByOwner")}
                    />
                  }
                  label={t<string>("travelByOwner")}
                />
              </Box>
              <Box
                style={{
                  display: vehicleData.travelByOwner ? "none" : "block",
                  marginTop: "24px",
                }}
              >
                <Grid container spacing={2}>
                  {/* <Grid item xs={12}>
                    {textFieldUpload(
                      "copyOfPowerOfAttorney",
                      t("copyOfPowerOfAttorney")
                    )}
                  </Grid> */}
                  <Grid item xs={12}>
                    {textFieldUpload(
                      "originalPowerOfAttorney",
                      t("originalPowerOfAttorney"),
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    {textFieldUpload(
                      "copyOfIDcardGrantee",
                      t("copyOfIDcardGrantee"),
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    {textFieldUpload("copyofCompany", t("copyofCompany"))}
                  </Grid>
                  <Grid item xs={12}>
                    {textFieldUpload(
                      "copyofCompanyIDcardGrantor",
                      t("copyofCompanyIDcardGrantor"),
                    )}
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>

          <Card sx={{ minWidth: 275 }} className={css.card}>
            <CardHeader title={t("contactInfo")}></CardHeader>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="phoneNumber"
                    label={t("phoneNumber")}
                    variant="outlined"
                    placeholder={t("phoneNumber")}
                    value={vehicleData.phoneNumber}
                    onChange={onValueChange("phoneNumber")}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="email"
                    label={t("email")}
                    variant="outlined"
                    placeholder={t("email")}
                    value={vehicleData.email}
                    onChange={onValueChange("email")}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="facebookID"
                    label={t("facebookID")}
                    variant="outlined"
                    placeholder={t("facebookID")}
                    value={vehicleData.facebookID}
                    onChange={onValueChange("facebookID")}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="lineID"
                    label={t("lineID")}
                    variant="outlined"
                    placeholder={t("lineID")}
                    value={vehicleData.lineID}
                    onChange={onValueChange("lineID")}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Box className={css.submitBtn}>
            <Button
              variant="contained"
              size="large"
              type="submit"
              startIcon={<SendIcon />}
              disabled={!isValid()}
            >
              {t("registerPage.submitBtn")}
            </Button>
          </Box>
        </form>
      </Container>
    </AppContainer>
  );
};
export default observer(ResgisterPage);
